module.exports = __webpack_public_path__ + "media/images/brand_icons/icon_yogasix-1f5027274964fe6b29d51eb49ce3f32e.svg";